import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsPage from "@/components/readings/ReadingsPage";

const ElectricityReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.electricity} />;
};

export default ElectricityReadingsPage;
